import React from 'react';
import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '../../hooks/useCurrentUser';

/**
 * Smart dashboard router: redirects to manager or agent dashboard based on role.
 */
function DashboardRouter() {
  const user = useCurrentUser();

  if (user === null) {
    return <div style={{ padding: '2rem', textAlign: 'center', color: '#64748b' }}>Carregando...</div>;
  }

  if (user.isManager) {
    return <Redirect to="/callcenterV2/dashboard/manager" />;
  }

  return <Redirect to="/callcenterV2/dashboard/agent" />;
}

export default DashboardRouter;
